import * as React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';

import { getServerTranslations } from '../../../lib/i18n/getServerTranslations';
import { DefaultLoadingUi } from '../../../components/restaurant-showcase';
import ShowCaseV2Content from '../../../components/showcase-v2';
import {
  RestaurantStaticType,
  fetchRestaurantInformation,
} from '../../../components/restaurant-showcase/server-side/fetch-restaurant-information';

const baseUrl = process.env.NEXT_PUBLIC_BASE_API_URL;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface INewShowCasePageProps {}

const NewShowCasePage: React.FunctionComponent<INewShowCasePageProps> = (props: RestaurantPageProps) => {
  const router = useRouter();
  if (router.isFallback) return <DefaultLoadingUi />;
  return <ShowCaseV2Content showCaseInformation={props.restaurantStatic} />;
};

export default NewShowCasePage;

export const getStaticPaths: GetStaticPaths = async () => {
  // Skip pre-rendering during build — pages are generated on-demand via fallback: true
  return { paths: [], fallback: true };
};
export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  const slug: string = params?.slug as string;
  if (!slug) {
    return {
      redirect: {
        destination: '/locale/not-found',
        permanent: false,
      },
    };
  }
  const staticProps = {
    revalidate: 60,
    props: {
      restaurantStatic: null,
      errorCode: null,
    },
  };
  const transConfig = await getServerTranslations(locale, [
    'common',
    'restaurant-showcase-v2',
    'restaurant-showcase-page',
    'onboarding-page',
  ]);
  try {
    const restaurantProccessed = await fetchRestaurantInformation(slug);
    return {
      ...staticProps,
      props: {
        ...staticProps.props,
        ...transConfig,
        restaurantStatic: restaurantProccessed,
      },
    };
  } catch (error) {
    // errore static restaurant data (silenzioso per lint)
    return {
      ...staticProps,
      props: {
        ...staticProps.props,
        ...transConfig,
        restaurantStatic: null,
      },
    };
  }
};

export interface RestaurantPageProps {
  restaurantStatic: RestaurantStaticType | null;
  errorCode?: number | null;
}
